/**
 * Map support
 */
(function() {
    $('.load-map-from-dummy').on('click', function (e) {
        e.preventDefault();
        const mapRoot = document.getElementById('map-root');
        if (mapRoot.getAttribute('data-status') !== 'enabled') {
            mapRoot.setAttribute('data-status', 'enabled');
            $(this).toggleClass('element-hidden-on-desktop');
        }
    });
})();